import React from "react";
import * as CHQ from "chq";

import { useProfile } from "app/context";
import { Trans } from "app/utils";

import NotificationBody from "./NotificationBody";

type PublicVideoStoryCreatedNotificationProps = {
  notification: CHQ.NotificationVideoStoryCreated;
};

const PublicVideoStoryCreatedNotification: React.FC<PublicVideoStoryCreatedNotificationProps> = ({
  notification: { entity }
}) => {
  const { profile } = useProfile();

  return (
    <NotificationBody actor={entity?.creator || profile}>
      <Trans>
        Your story was created! An admin will review it to be approved.
        You can create more stories if you want!
      </Trans>
    </NotificationBody>
  );
};

export default PublicVideoStoryCreatedNotification;
